<template>
    <ui-modal>
        <template #header>
            <h3 class="mb-1 text-center" v-text="configTariffTitle" />
            <h5 class="mb-0 text-center" v-text="'Podsumowanie koszyka'" />
        </template>

        <div class="text-sm a-infoBar a-infoBar--warning mb-3">
            Zamówienie składasz do Comp S.A. – spółki dostarczającej usługę „{{ drsService.name }}”
        </div>

        <h4 v-text="'Podsumowanie koszyka:'" />

        <summary-shop
            v-for="shop in selectedShops"
            :key="shop.id"
            :shop="shop"
            :is-expanded="expandedShopIds.includes(shop.id)"
            @expand-shop="expandShop(shop.id)"
        />

        <recap-table />

        <template #footer>
            <the-btn
                class="btn-outline-custom"
                :text="isMappingConfigMode ? 'Zamknij' : 'Wróć'"
                @click="goBack"
            />
            <the-btn
                class="btn-secondary"
                text="Zamawiam pakiet"
                :disabled="isSubmitLoading"
                :loading-status="isSubmitLoading ? 'loading' : 'idle'"
                :icon="isSubmitLoading ? 'Spinner' : ''"
                @click="saveConfiguration"
            />
        </template>
    </ui-modal>
</template>

<script>
import RecapTable from './RecapTable.vue'
import { mapActions, mapGetters } from 'vuex'
import { SERVICE_CODE } from '@/store/modules/drs/drs.module'
import cloneDumb from '@/helpers/cloneDumb'
import { COMPANY_STATUSES } from '@/utils/constants/drs/company-statuses'
import { TIMELINES } from '@/utils/constants/drs/tariffs'
import { CONFIG_MODES } from '@/store/modules/drs/tariffs.module'

export default {
    data: () => ({
        expandedShopIds: [],
        isLoading: false
    }),

    computed: {
        ...mapGetters('drsTariffs', ['selectedTariff', 'configTariffTitle', 'configMode', 'selectedPaymentType', 'isCartLoading']),
        ...mapGetters('drs', ['nip', 'companiesData', 'companyStatus']),

        selectedShops() {
            return this.selectedTariff.locations.filter(el => el.selected)
        },

        user() {
            return this.$store.getters.getUser
        },

        tariff() {
            // Get first tariff
            return this.selectedTariff
        },

        drsService() {
            return this.$store.getters.getServiceByCode(SERVICE_CODE)
        },

        isMappingConfigMode() {
            return this.configMode === CONFIG_MODES.MAPPING
        },

        isSubmitLoading() {
            return this.isLoading || this.isCartLoading
        },

        canSaveWithoutPayment() {
            if (this.tariff?.timeline === TIMELINES.YEARLY) {
                // Yearly tariffs always require payment
                return false
            }

            return this.configMode === CONFIG_MODES.EDIT ||
                this.companyStatus === COMPANY_STATUSES.VERIFIED
        }
    },

    methods: {
        ...mapActions('drs', ['getCurrentTransaction', 'loadDataAndCheckPermission']),
        ...mapActions('drsTariffs', ['postSubscription']),

        async saveConfiguration() {
            if (this.isSubmitLoading) {
                // Prevent rage clicks
                return
            }

            if (!this.canSaveWithoutPayment) {
                this.$store.dispatch('openModal', {
                    componentPath: 'drs/configuration/PaymentForm'
                })
                return
            }

            this.isLoading = true
            await this.postSubscription().then(async () => {
                await this.loadDataAndCheckPermission()
                this.$store.dispatch('openModal', {
                    componentPath: 'drs/configuration/ThanksModal',
                    args: {
                        shopsList: cloneDumb(this.selectedShops)
                    }
                })
            }).catch(() => {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Wystąpił błąd'
                })
            }).finally(() => {
                this.isLoading = false
            })
        },

        expandShop(shopId) {
            this.expandedShopIds = this.expandedShopIds.includes(shopId)
                ? this.expandedShopIds.filter(id => id !== shopId)
                : [...this.expandedShopIds, shopId]
        },

        goBack() {
            if (this.isMappingConfigMode) {
                this.$store.dispatch('toggleModal', false)
                return
            }

            this.$store.dispatch('openModal', {
                componentPath: 'drs/configuration/SelectShop'
            })
        }
    },

    components: {
        RecapTable
    },

    created() {
        this.expandedShopIds = this.selectedShops.map(shop => shop.id)
    }
}
</script>
